import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {OrderDataConveyed} from '../../order-request.models';

@Component({
    selector: 'order-box-history-conveyed',
    templateUrl: './order-box-history-conveyed.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderBoxHistoryConveyedComponent {

  @Input() type: string;
  @Input() history: OrderDataConveyed;

  constructor() {
  }
}
